/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as PublicIndexRouteImport } from './routes/_public.index'
import { Route as PortalLoginRouteImport } from './routes/portal.login'
import { Route as PortalAuthRouteImport } from './routes/portal.auth'
import { Route as CertificatesCsrRouteImport } from './routes/certificates.csr'
import { Route as PublicTerminosRouteImport } from './routes/_public.terminos'
import { Route as PublicStatusRouteImport } from './routes/_public.status'
import { Route as PublicSignupRouteImport } from './routes/_public.signup'
import { Route as PublicRoadmapRouteImport } from './routes/_public.roadmap'
import { Route as PublicProductosRouteImport } from './routes/_public.productos'
import { Route as PublicPrivacidadRouteImport } from './routes/_public.privacidad'
import { Route as PublicPreciosRouteImport } from './routes/_public.precios'
import { Route as PublicLoginRouteImport } from './routes/_public.login'
import { Route as PublicDevelopersRouteImport } from './routes/_public.developers'
import { Route as PublicCookiesRouteImport } from './routes/_public.cookies'
import { Route as PublicContactoRouteImport } from './routes/_public.contacto'
import { Route as PublicChangelogRouteImport } from './routes/_public.changelog'
import { Route as PublicCarrerasRouteImport } from './routes/_public.carreras'
import { Route as PublicBlogRouteImport } from './routes/_public.blog'
import { Route as PublicAboutRouteImport } from './routes/_public.about'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated.settings'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated.onboarding'
import { Route as AuthenticatedGuiaInicioRouteImport } from './routes/_authenticated.guia-inicio'
import { Route as AuthenticatedGuiaAfipRouteImport } from './routes/_authenticated.guia-afip'
import { Route as AuthenticatedEnablementRoomsRouteImport } from './routes/_authenticated.enablement-rooms'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated.audit'
import { Route as AuthenticatedApiDocsRouteImport } from './routes/_authenticated.api-docs'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AuthenticatedActividadesRouteImport } from './routes/_authenticated.actividades'
import { Route as AuthenticatedWebhooksIndexRouteImport } from './routes/_authenticated.webhooks.index'
import { Route as AuthenticatedVepIndexRouteImport } from './routes/_authenticated.vep.index'
import { Route as AuthenticatedVentanillaVirtualIndexRouteImport } from './routes/_authenticated.ventanilla-virtual.index'
import { Route as AuthenticatedVencimientosIndexRouteImport } from './routes/_authenticated.vencimientos.index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated.users.index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated.roles.index'
import { Route as AuthenticatedReportesIndexRouteImport } from './routes/_authenticated.reportes.index'
import { Route as AuthenticatedRecurrentesIndexRouteImport } from './routes/_authenticated.recurrentes.index'
import { Route as AuthenticatedReceptoresIndexRouteImport } from './routes/_authenticated.receptores.index'
import { Route as AuthenticatedParaguayIndexRouteImport } from './routes/_authenticated.paraguay.index'
import { Route as AuthenticatedIvaIndexRouteImport } from './routes/_authenticated.iva.index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated.invoices.index'
import { Route as AuthenticatedHonorariosIndexRouteImport } from './routes/_authenticated.honorarios.index'
import { Route as AuthenticatedCuitProfilesIndexRouteImport } from './routes/_authenticated.cuit-profiles.index'
import { Route as AuthenticatedCredencialesIndexRouteImport } from './routes/_authenticated.credenciales.index'
import { Route as AuthenticatedConsumoIndexRouteImport } from './routes/_authenticated.consumo.index'
import { Route as AuthenticatedCobranzasIndexRouteImport } from './routes/_authenticated.cobranzas.index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated.clients.index'
import { Route as AuthenticatedCertificadosIndexRouteImport } from './routes/_authenticated.certificados.index'
import { Route as AuthenticatedBillingIndexRouteImport } from './routes/_authenticated.billing.index'
import { Route as AuthenticatedAplicacionesIndexRouteImport } from './routes/_authenticated.aplicaciones.index'
import { Route as AuthenticatedApiLogsIndexRouteImport } from './routes/_authenticated.api-logs.index'
import { Route as AuthenticatedAlertsIndexRouteImport } from './routes/_authenticated.alerts.index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated.admin.index'
import { Route as PublicEstudiosAmigosAceptarRouteImport } from './routes/_public.estudios-amigos.aceptar'
import { Route as PublicDevelopersPagosRouteImport } from './routes/_public.developers.pagos'
import { Route as PublicAuthVerifyEmailRouteImport } from './routes/_public.auth.verify-email'
import { Route as PublicAuthMagicRouteImport } from './routes/_public.auth.magic'
import { Route as AuthenticatedInvoicesImportRouteImport } from './routes/_authenticated.invoices.import'
import { Route as AuthenticatedInvoicesIdRouteImport } from './routes/_authenticated.invoices.$id'
import { Route as AuthenticatedDashboardMetricsRouteImport } from './routes/_authenticated.dashboard.metrics'
import { Route as AuthenticatedDashboardFacturacionRouteImport } from './routes/_authenticated.dashboard.facturacion'
import { Route as AuthenticatedDashboardEmpresaRouteImport } from './routes/_authenticated.dashboard.empresa'
import { Route as AuthenticatedDashboardApiRouteImport } from './routes/_authenticated.dashboard.api'
import { Route as AuthenticatedCuitProfilesNewRouteImport } from './routes/_authenticated.cuit-profiles.new'
import { Route as AuthenticatedCuitProfilesIdRouteImport } from './routes/_authenticated.cuit-profiles.$id'
import { Route as AuthenticatedClientsNewRouteImport } from './routes/_authenticated.clients.new'
import { Route as AuthenticatedBillingHistoryRouteImport } from './routes/_authenticated.billing.history'
import { Route as AuthenticatedAlertsCategoryChangeRouteImport } from './routes/_authenticated.alerts.category-change'
import { Route as AuthenticatedAdminWorkersIndexRouteImport } from './routes/_authenticated.admin.workers.index'
import { Route as AuthenticatedAdminTenantsIndexRouteImport } from './routes/_authenticated.admin.tenants.index'
import { Route as AuthenticatedAdminSuscripcionesIndexRouteImport } from './routes/_authenticated.admin.suscripciones.index'
import { Route as AuthenticatedAdminPagosIndexRouteImport } from './routes/_authenticated.admin.pagos.index'
import { Route as AuthenticatedAdminOrganizacionesIndexRouteImport } from './routes/_authenticated.admin.organizaciones.index'
import { Route as AuthenticatedAdminFeatureFlagsIndexRouteImport } from './routes/_authenticated.admin.feature-flags.index'
import { Route as AuthenticatedAdminEstudiosAmigosIndexRouteImport } from './routes/_authenticated.admin.estudios-amigos.index'
import { Route as AuthenticatedAdminEstadoIndexRouteImport } from './routes/_authenticated.admin.estado.index'
import { Route as AuthenticatedAdminCuponesIndexRouteImport } from './routes/_authenticated.admin.cupones.index'
import { Route as AuthenticatedAdminConfiguracionIndexRouteImport } from './routes/_authenticated.admin.configuracion.index'
import { Route as AuthenticatedAdminComprobantesIndexRouteImport } from './routes/_authenticated.admin.comprobantes.index'
import { Route as AuthenticatedAdminCertificadosIndexRouteImport } from './routes/_authenticated.admin.certificados.index'
import { Route as AuthenticatedAdminBuscarIndexRouteImport } from './routes/_authenticated.admin.buscar.index'
import { Route as AuthenticatedAdminAuditoriaIndexRouteImport } from './routes/_authenticated.admin.auditoria.index'
import { Route as AuthenticatedAdminAnunciosIndexRouteImport } from './routes/_authenticated.admin.anuncios.index'
import { Route as AuthenticatedInvoicesIdEditRouteImport } from './routes/_authenticated.invoices.$id.edit'
import { Route as AuthenticatedCuitProfilesIdEnablementRouteImport } from './routes/_authenticated.cuit-profiles.$id.enablement'
import { Route as AuthenticatedBillingCheckoutReturnRouteImport } from './routes/_authenticated.billing.checkout.return'
import { Route as AuthenticatedAdminTenantsIdRouteImport } from './routes/_authenticated.admin.tenants.$id'

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PortalLoginRoute = PortalLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAuthRoute = PortalAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => PortalRoute,
} as any)
const CertificatesCsrRoute = CertificatesCsrRouteImport.update({
  id: '/certificates/csr',
  path: '/certificates/csr',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTerminosRoute = PublicTerminosRouteImport.update({
  id: '/terminos',
  path: '/terminos',
  getParentRoute: () => PublicRoute,
} as any)
const PublicStatusRoute = PublicStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRoadmapRoute = PublicRoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => PublicRoute,
} as any)
const PublicProductosRoute = PublicProductosRouteImport.update({
  id: '/productos',
  path: '/productos',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPrivacidadRoute = PublicPrivacidadRouteImport.update({
  id: '/privacidad',
  path: '/privacidad',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPreciosRoute = PublicPreciosRouteImport.update({
  id: '/precios',
  path: '/precios',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDevelopersRoute = PublicDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCookiesRoute = PublicCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => PublicRoute,
} as any)
const PublicContactoRoute = PublicContactoRouteImport.update({
  id: '/contacto',
  path: '/contacto',
  getParentRoute: () => PublicRoute,
} as any)
const PublicChangelogRoute = PublicChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCarrerasRoute = PublicCarrerasRouteImport.update({
  id: '/carreras',
  path: '/carreras',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogRoute = PublicBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGuiaInicioRoute = AuthenticatedGuiaInicioRouteImport.update({
  id: '/guia-inicio',
  path: '/guia-inicio',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGuiaAfipRoute = AuthenticatedGuiaAfipRouteImport.update({
  id: '/guia-afip',
  path: '/guia-afip',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEnablementRoomsRoute =
  AuthenticatedEnablementRoomsRouteImport.update({
    id: '/enablement-rooms',
    path: '/enablement-rooms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApiDocsRoute = AuthenticatedApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActividadesRoute =
  AuthenticatedActividadesRouteImport.update({
    id: '/actividades',
    path: '/actividades',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebhooksIndexRoute =
  AuthenticatedWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVepIndexRoute = AuthenticatedVepIndexRouteImport.update({
  id: '/vep/',
  path: '/vep/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVentanillaVirtualIndexRoute =
  AuthenticatedVentanillaVirtualIndexRouteImport.update({
    id: '/ventanilla-virtual/',
    path: '/ventanilla-virtual/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedVencimientosIndexRoute =
  AuthenticatedVencimientosIndexRouteImport.update({
    id: '/vencimientos/',
    path: '/vencimientos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportesIndexRoute =
  AuthenticatedReportesIndexRouteImport.update({
    id: '/reportes/',
    path: '/reportes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRecurrentesIndexRoute =
  AuthenticatedRecurrentesIndexRouteImport.update({
    id: '/recurrentes/',
    path: '/recurrentes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReceptoresIndexRoute =
  AuthenticatedReceptoresIndexRouteImport.update({
    id: '/receptores/',
    path: '/receptores/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedParaguayIndexRoute =
  AuthenticatedParaguayIndexRouteImport.update({
    id: '/paraguay/',
    path: '/paraguay/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIvaIndexRoute = AuthenticatedIvaIndexRouteImport.update({
  id: '/iva/',
  path: '/iva/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHonorariosIndexRoute =
  AuthenticatedHonorariosIndexRouteImport.update({
    id: '/honorarios/',
    path: '/honorarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCuitProfilesIndexRoute =
  AuthenticatedCuitProfilesIndexRouteImport.update({
    id: '/cuit-profiles/',
    path: '/cuit-profiles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCredencialesIndexRoute =
  AuthenticatedCredencialesIndexRouteImport.update({
    id: '/credenciales/',
    path: '/credenciales/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConsumoIndexRoute =
  AuthenticatedConsumoIndexRouteImport.update({
    id: '/consumo/',
    path: '/consumo/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCobranzasIndexRoute =
  AuthenticatedCobranzasIndexRouteImport.update({
    id: '/cobranzas/',
    path: '/cobranzas/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificadosIndexRoute =
  AuthenticatedCertificadosIndexRouteImport.update({
    id: '/certificados/',
    path: '/certificados/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingIndexRoute =
  AuthenticatedBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAplicacionesIndexRoute =
  AuthenticatedAplicacionesIndexRouteImport.update({
    id: '/aplicaciones/',
    path: '/aplicaciones/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiLogsIndexRoute =
  AuthenticatedApiLogsIndexRouteImport.update({
    id: '/api-logs/',
    path: '/api-logs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAlertsIndexRoute =
  AuthenticatedAlertsIndexRouteImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const PublicEstudiosAmigosAceptarRoute =
  PublicEstudiosAmigosAceptarRouteImport.update({
    id: '/estudios-amigos/aceptar',
    path: '/estudios-amigos/aceptar',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicDevelopersPagosRoute = PublicDevelopersPagosRouteImport.update({
  id: '/pagos',
  path: '/pagos',
  getParentRoute: () => PublicDevelopersRoute,
} as any)
const PublicAuthVerifyEmailRoute = PublicAuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthMagicRoute = PublicAuthMagicRouteImport.update({
  id: '/auth/magic',
  path: '/auth/magic',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedInvoicesImportRoute =
  AuthenticatedInvoicesImportRouteImport.update({
    id: '/invoices/import',
    path: '/invoices/import',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesIdRoute = AuthenticatedInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardMetricsRoute =
  AuthenticatedDashboardMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardFacturacionRoute =
  AuthenticatedDashboardFacturacionRouteImport.update({
    id: '/facturacion',
    path: '/facturacion',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardEmpresaRoute =
  AuthenticatedDashboardEmpresaRouteImport.update({
    id: '/empresa',
    path: '/empresa',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardApiRoute =
  AuthenticatedDashboardApiRouteImport.update({
    id: '/api',
    path: '/api',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedCuitProfilesNewRoute =
  AuthenticatedCuitProfilesNewRouteImport.update({
    id: '/cuit-profiles/new',
    path: '/cuit-profiles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCuitProfilesIdRoute =
  AuthenticatedCuitProfilesIdRouteImport.update({
    id: '/cuit-profiles/$id',
    path: '/cuit-profiles/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsNewRoute = AuthenticatedClientsNewRouteImport.update({
  id: '/clients/new',
  path: '/clients/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBillingHistoryRoute =
  AuthenticatedBillingHistoryRouteImport.update({
    id: '/billing/history',
    path: '/billing/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAlertsCategoryChangeRoute =
  AuthenticatedAlertsCategoryChangeRouteImport.update({
    id: '/alerts/category-change',
    path: '/alerts/category-change',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminWorkersIndexRoute =
  AuthenticatedAdminWorkersIndexRouteImport.update({
    id: '/workers/',
    path: '/workers/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminTenantsIndexRoute =
  AuthenticatedAdminTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSuscripcionesIndexRoute =
  AuthenticatedAdminSuscripcionesIndexRouteImport.update({
    id: '/suscripciones/',
    path: '/suscripciones/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPagosIndexRoute =
  AuthenticatedAdminPagosIndexRouteImport.update({
    id: '/pagos/',
    path: '/pagos/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrganizacionesIndexRoute =
  AuthenticatedAdminOrganizacionesIndexRouteImport.update({
    id: '/organizaciones/',
    path: '/organizaciones/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminFeatureFlagsIndexRoute =
  AuthenticatedAdminFeatureFlagsIndexRouteImport.update({
    id: '/feature-flags/',
    path: '/feature-flags/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminEstudiosAmigosIndexRoute =
  AuthenticatedAdminEstudiosAmigosIndexRouteImport.update({
    id: '/estudios-amigos/',
    path: '/estudios-amigos/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminEstadoIndexRoute =
  AuthenticatedAdminEstadoIndexRouteImport.update({
    id: '/estado/',
    path: '/estado/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCuponesIndexRoute =
  AuthenticatedAdminCuponesIndexRouteImport.update({
    id: '/cupones/',
    path: '/cupones/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminConfiguracionIndexRoute =
  AuthenticatedAdminConfiguracionIndexRouteImport.update({
    id: '/configuracion/',
    path: '/configuracion/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminComprobantesIndexRoute =
  AuthenticatedAdminComprobantesIndexRouteImport.update({
    id: '/comprobantes/',
    path: '/comprobantes/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCertificadosIndexRoute =
  AuthenticatedAdminCertificadosIndexRouteImport.update({
    id: '/certificados/',
    path: '/certificados/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBuscarIndexRoute =
  AuthenticatedAdminBuscarIndexRouteImport.update({
    id: '/buscar/',
    path: '/buscar/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditoriaIndexRoute =
  AuthenticatedAdminAuditoriaIndexRouteImport.update({
    id: '/auditoria/',
    path: '/auditoria/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAnunciosIndexRoute =
  AuthenticatedAdminAnunciosIndexRouteImport.update({
    id: '/anuncios/',
    path: '/anuncios/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedInvoicesIdEditRoute =
  AuthenticatedInvoicesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedInvoicesIdRoute,
  } as any)
const AuthenticatedCuitProfilesIdEnablementRoute =
  AuthenticatedCuitProfilesIdEnablementRouteImport.update({
    id: '/enablement',
    path: '/enablement',
    getParentRoute: () => AuthenticatedCuitProfilesIdRoute,
  } as any)
const AuthenticatedBillingCheckoutReturnRoute =
  AuthenticatedBillingCheckoutReturnRouteImport.update({
    id: '/billing/checkout/return',
    path: '/billing/checkout/return',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminTenantsIdRoute =
  AuthenticatedAdminTenantsIdRouteImport.update({
    id: '/tenants/$id',
    path: '/tenants/$id',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/portal': typeof PortalRouteWithChildren
  '/actividades': typeof AuthenticatedActividadesRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/api-docs': typeof AuthenticatedApiDocsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/enablement-rooms': typeof AuthenticatedEnablementRoomsRoute
  '/guia-afip': typeof AuthenticatedGuiaAfipRoute
  '/guia-inicio': typeof AuthenticatedGuiaInicioRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/about': typeof PublicAboutRoute
  '/blog': typeof PublicBlogRoute
  '/carreras': typeof PublicCarrerasRoute
  '/changelog': typeof PublicChangelogRoute
  '/contacto': typeof PublicContactoRoute
  '/cookies': typeof PublicCookiesRoute
  '/developers': typeof PublicDevelopersRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/precios': typeof PublicPreciosRoute
  '/privacidad': typeof PublicPrivacidadRoute
  '/productos': typeof PublicProductosRoute
  '/roadmap': typeof PublicRoadmapRoute
  '/signup': typeof PublicSignupRoute
  '/status': typeof PublicStatusRoute
  '/terminos': typeof PublicTerminosRoute
  '/certificates/csr': typeof CertificatesCsrRoute
  '/portal/auth': typeof PortalAuthRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/': typeof PortalIndexRoute
  '/alerts/category-change': typeof AuthenticatedAlertsCategoryChangeRoute
  '/billing/history': typeof AuthenticatedBillingHistoryRoute
  '/clients/new': typeof AuthenticatedClientsNewRoute
  '/cuit-profiles/$id': typeof AuthenticatedCuitProfilesIdRouteWithChildren
  '/cuit-profiles/new': typeof AuthenticatedCuitProfilesNewRoute
  '/dashboard/api': typeof AuthenticatedDashboardApiRoute
  '/dashboard/empresa': typeof AuthenticatedDashboardEmpresaRoute
  '/dashboard/facturacion': typeof AuthenticatedDashboardFacturacionRoute
  '/dashboard/metrics': typeof AuthenticatedDashboardMetricsRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdRouteWithChildren
  '/invoices/import': typeof AuthenticatedInvoicesImportRoute
  '/auth/magic': typeof PublicAuthMagicRoute
  '/auth/verify-email': typeof PublicAuthVerifyEmailRoute
  '/developers/pagos': typeof PublicDevelopersPagosRoute
  '/estudios-amigos/aceptar': typeof PublicEstudiosAmigosAceptarRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/api-logs/': typeof AuthenticatedApiLogsIndexRoute
  '/aplicaciones/': typeof AuthenticatedAplicacionesIndexRoute
  '/billing/': typeof AuthenticatedBillingIndexRoute
  '/certificados/': typeof AuthenticatedCertificadosIndexRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/cobranzas/': typeof AuthenticatedCobranzasIndexRoute
  '/consumo/': typeof AuthenticatedConsumoIndexRoute
  '/credenciales/': typeof AuthenticatedCredencialesIndexRoute
  '/cuit-profiles/': typeof AuthenticatedCuitProfilesIndexRoute
  '/honorarios/': typeof AuthenticatedHonorariosIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/iva/': typeof AuthenticatedIvaIndexRoute
  '/paraguay/': typeof AuthenticatedParaguayIndexRoute
  '/receptores/': typeof AuthenticatedReceptoresIndexRoute
  '/recurrentes/': typeof AuthenticatedRecurrentesIndexRoute
  '/reportes/': typeof AuthenticatedReportesIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/vencimientos/': typeof AuthenticatedVencimientosIndexRoute
  '/ventanilla-virtual/': typeof AuthenticatedVentanillaVirtualIndexRoute
  '/vep/': typeof AuthenticatedVepIndexRoute
  '/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/admin/tenants/$id': typeof AuthenticatedAdminTenantsIdRoute
  '/billing/checkout/return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/cuit-profiles/$id/enablement': typeof AuthenticatedCuitProfilesIdEnablementRoute
  '/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/admin/anuncios/': typeof AuthenticatedAdminAnunciosIndexRoute
  '/admin/auditoria/': typeof AuthenticatedAdminAuditoriaIndexRoute
  '/admin/buscar/': typeof AuthenticatedAdminBuscarIndexRoute
  '/admin/certificados/': typeof AuthenticatedAdminCertificadosIndexRoute
  '/admin/comprobantes/': typeof AuthenticatedAdminComprobantesIndexRoute
  '/admin/configuracion/': typeof AuthenticatedAdminConfiguracionIndexRoute
  '/admin/cupones/': typeof AuthenticatedAdminCuponesIndexRoute
  '/admin/estado/': typeof AuthenticatedAdminEstadoIndexRoute
  '/admin/estudios-amigos/': typeof AuthenticatedAdminEstudiosAmigosIndexRoute
  '/admin/feature-flags/': typeof AuthenticatedAdminFeatureFlagsIndexRoute
  '/admin/organizaciones/': typeof AuthenticatedAdminOrganizacionesIndexRoute
  '/admin/pagos/': typeof AuthenticatedAdminPagosIndexRoute
  '/admin/suscripciones/': typeof AuthenticatedAdminSuscripcionesIndexRoute
  '/admin/tenants/': typeof AuthenticatedAdminTenantsIndexRoute
  '/admin/workers/': typeof AuthenticatedAdminWorkersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/actividades': typeof AuthenticatedActividadesRoute
  '/api-docs': typeof AuthenticatedApiDocsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/enablement-rooms': typeof AuthenticatedEnablementRoomsRoute
  '/guia-afip': typeof AuthenticatedGuiaAfipRoute
  '/guia-inicio': typeof AuthenticatedGuiaInicioRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/about': typeof PublicAboutRoute
  '/blog': typeof PublicBlogRoute
  '/carreras': typeof PublicCarrerasRoute
  '/changelog': typeof PublicChangelogRoute
  '/contacto': typeof PublicContactoRoute
  '/cookies': typeof PublicCookiesRoute
  '/developers': typeof PublicDevelopersRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/precios': typeof PublicPreciosRoute
  '/privacidad': typeof PublicPrivacidadRoute
  '/productos': typeof PublicProductosRoute
  '/roadmap': typeof PublicRoadmapRoute
  '/signup': typeof PublicSignupRoute
  '/status': typeof PublicStatusRoute
  '/terminos': typeof PublicTerminosRoute
  '/certificates/csr': typeof CertificatesCsrRoute
  '/portal/auth': typeof PortalAuthRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal': typeof PortalIndexRoute
  '/alerts/category-change': typeof AuthenticatedAlertsCategoryChangeRoute
  '/billing/history': typeof AuthenticatedBillingHistoryRoute
  '/clients/new': typeof AuthenticatedClientsNewRoute
  '/cuit-profiles/$id': typeof AuthenticatedCuitProfilesIdRouteWithChildren
  '/cuit-profiles/new': typeof AuthenticatedCuitProfilesNewRoute
  '/dashboard/api': typeof AuthenticatedDashboardApiRoute
  '/dashboard/empresa': typeof AuthenticatedDashboardEmpresaRoute
  '/dashboard/facturacion': typeof AuthenticatedDashboardFacturacionRoute
  '/dashboard/metrics': typeof AuthenticatedDashboardMetricsRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdRouteWithChildren
  '/invoices/import': typeof AuthenticatedInvoicesImportRoute
  '/auth/magic': typeof PublicAuthMagicRoute
  '/auth/verify-email': typeof PublicAuthVerifyEmailRoute
  '/developers/pagos': typeof PublicDevelopersPagosRoute
  '/estudios-amigos/aceptar': typeof PublicEstudiosAmigosAceptarRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/alerts': typeof AuthenticatedAlertsIndexRoute
  '/api-logs': typeof AuthenticatedApiLogsIndexRoute
  '/aplicaciones': typeof AuthenticatedAplicacionesIndexRoute
  '/billing': typeof AuthenticatedBillingIndexRoute
  '/certificados': typeof AuthenticatedCertificadosIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/cobranzas': typeof AuthenticatedCobranzasIndexRoute
  '/consumo': typeof AuthenticatedConsumoIndexRoute
  '/credenciales': typeof AuthenticatedCredencialesIndexRoute
  '/cuit-profiles': typeof AuthenticatedCuitProfilesIndexRoute
  '/honorarios': typeof AuthenticatedHonorariosIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/iva': typeof AuthenticatedIvaIndexRoute
  '/paraguay': typeof AuthenticatedParaguayIndexRoute
  '/receptores': typeof AuthenticatedReceptoresIndexRoute
  '/recurrentes': typeof AuthenticatedRecurrentesIndexRoute
  '/reportes': typeof AuthenticatedReportesIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/vencimientos': typeof AuthenticatedVencimientosIndexRoute
  '/ventanilla-virtual': typeof AuthenticatedVentanillaVirtualIndexRoute
  '/vep': typeof AuthenticatedVepIndexRoute
  '/webhooks': typeof AuthenticatedWebhooksIndexRoute
  '/admin/tenants/$id': typeof AuthenticatedAdminTenantsIdRoute
  '/billing/checkout/return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/cuit-profiles/$id/enablement': typeof AuthenticatedCuitProfilesIdEnablementRoute
  '/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/admin/anuncios': typeof AuthenticatedAdminAnunciosIndexRoute
  '/admin/auditoria': typeof AuthenticatedAdminAuditoriaIndexRoute
  '/admin/buscar': typeof AuthenticatedAdminBuscarIndexRoute
  '/admin/certificados': typeof AuthenticatedAdminCertificadosIndexRoute
  '/admin/comprobantes': typeof AuthenticatedAdminComprobantesIndexRoute
  '/admin/configuracion': typeof AuthenticatedAdminConfiguracionIndexRoute
  '/admin/cupones': typeof AuthenticatedAdminCuponesIndexRoute
  '/admin/estado': typeof AuthenticatedAdminEstadoIndexRoute
  '/admin/estudios-amigos': typeof AuthenticatedAdminEstudiosAmigosIndexRoute
  '/admin/feature-flags': typeof AuthenticatedAdminFeatureFlagsIndexRoute
  '/admin/organizaciones': typeof AuthenticatedAdminOrganizacionesIndexRoute
  '/admin/pagos': typeof AuthenticatedAdminPagosIndexRoute
  '/admin/suscripciones': typeof AuthenticatedAdminSuscripcionesIndexRoute
  '/admin/tenants': typeof AuthenticatedAdminTenantsIndexRoute
  '/admin/workers': typeof AuthenticatedAdminWorkersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/portal': typeof PortalRouteWithChildren
  '/_authenticated/actividades': typeof AuthenticatedActividadesRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/api-docs': typeof AuthenticatedApiDocsRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/enablement-rooms': typeof AuthenticatedEnablementRoomsRoute
  '/_authenticated/guia-afip': typeof AuthenticatedGuiaAfipRoute
  '/_authenticated/guia-inicio': typeof AuthenticatedGuiaInicioRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_public/about': typeof PublicAboutRoute
  '/_public/blog': typeof PublicBlogRoute
  '/_public/carreras': typeof PublicCarrerasRoute
  '/_public/changelog': typeof PublicChangelogRoute
  '/_public/contacto': typeof PublicContactoRoute
  '/_public/cookies': typeof PublicCookiesRoute
  '/_public/developers': typeof PublicDevelopersRouteWithChildren
  '/_public/login': typeof PublicLoginRoute
  '/_public/precios': typeof PublicPreciosRoute
  '/_public/privacidad': typeof PublicPrivacidadRoute
  '/_public/productos': typeof PublicProductosRoute
  '/_public/roadmap': typeof PublicRoadmapRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/status': typeof PublicStatusRoute
  '/_public/terminos': typeof PublicTerminosRoute
  '/certificates/csr': typeof CertificatesCsrRoute
  '/portal/auth': typeof PortalAuthRoute
  '/portal/login': typeof PortalLoginRoute
  '/_public/': typeof PublicIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_authenticated/alerts/category-change': typeof AuthenticatedAlertsCategoryChangeRoute
  '/_authenticated/billing/history': typeof AuthenticatedBillingHistoryRoute
  '/_authenticated/clients/new': typeof AuthenticatedClientsNewRoute
  '/_authenticated/cuit-profiles/$id': typeof AuthenticatedCuitProfilesIdRouteWithChildren
  '/_authenticated/cuit-profiles/new': typeof AuthenticatedCuitProfilesNewRoute
  '/_authenticated/dashboard/api': typeof AuthenticatedDashboardApiRoute
  '/_authenticated/dashboard/empresa': typeof AuthenticatedDashboardEmpresaRoute
  '/_authenticated/dashboard/facturacion': typeof AuthenticatedDashboardFacturacionRoute
  '/_authenticated/dashboard/metrics': typeof AuthenticatedDashboardMetricsRoute
  '/_authenticated/invoices/$id': typeof AuthenticatedInvoicesIdRouteWithChildren
  '/_authenticated/invoices/import': typeof AuthenticatedInvoicesImportRoute
  '/_public/auth/magic': typeof PublicAuthMagicRoute
  '/_public/auth/verify-email': typeof PublicAuthVerifyEmailRoute
  '/_public/developers/pagos': typeof PublicDevelopersPagosRoute
  '/_public/estudios-amigos/aceptar': typeof PublicEstudiosAmigosAceptarRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/_authenticated/api-logs/': typeof AuthenticatedApiLogsIndexRoute
  '/_authenticated/aplicaciones/': typeof AuthenticatedAplicacionesIndexRoute
  '/_authenticated/billing/': typeof AuthenticatedBillingIndexRoute
  '/_authenticated/certificados/': typeof AuthenticatedCertificadosIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/cobranzas/': typeof AuthenticatedCobranzasIndexRoute
  '/_authenticated/consumo/': typeof AuthenticatedConsumoIndexRoute
  '/_authenticated/credenciales/': typeof AuthenticatedCredencialesIndexRoute
  '/_authenticated/cuit-profiles/': typeof AuthenticatedCuitProfilesIndexRoute
  '/_authenticated/honorarios/': typeof AuthenticatedHonorariosIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/iva/': typeof AuthenticatedIvaIndexRoute
  '/_authenticated/paraguay/': typeof AuthenticatedParaguayIndexRoute
  '/_authenticated/receptores/': typeof AuthenticatedReceptoresIndexRoute
  '/_authenticated/recurrentes/': typeof AuthenticatedRecurrentesIndexRoute
  '/_authenticated/reportes/': typeof AuthenticatedReportesIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/vencimientos/': typeof AuthenticatedVencimientosIndexRoute
  '/_authenticated/ventanilla-virtual/': typeof AuthenticatedVentanillaVirtualIndexRoute
  '/_authenticated/vep/': typeof AuthenticatedVepIndexRoute
  '/_authenticated/webhooks/': typeof AuthenticatedWebhooksIndexRoute
  '/_authenticated/admin/tenants/$id': typeof AuthenticatedAdminTenantsIdRoute
  '/_authenticated/billing/checkout/return': typeof AuthenticatedBillingCheckoutReturnRoute
  '/_authenticated/cuit-profiles/$id/enablement': typeof AuthenticatedCuitProfilesIdEnablementRoute
  '/_authenticated/invoices/$id/edit': typeof AuthenticatedInvoicesIdEditRoute
  '/_authenticated/admin/anuncios/': typeof AuthenticatedAdminAnunciosIndexRoute
  '/_authenticated/admin/auditoria/': typeof AuthenticatedAdminAuditoriaIndexRoute
  '/_authenticated/admin/buscar/': typeof AuthenticatedAdminBuscarIndexRoute
  '/_authenticated/admin/certificados/': typeof AuthenticatedAdminCertificadosIndexRoute
  '/_authenticated/admin/comprobantes/': typeof AuthenticatedAdminComprobantesIndexRoute
  '/_authenticated/admin/configuracion/': typeof AuthenticatedAdminConfiguracionIndexRoute
  '/_authenticated/admin/cupones/': typeof AuthenticatedAdminCuponesIndexRoute
  '/_authenticated/admin/estado/': typeof AuthenticatedAdminEstadoIndexRoute
  '/_authenticated/admin/estudios-amigos/': typeof AuthenticatedAdminEstudiosAmigosIndexRoute
  '/_authenticated/admin/feature-flags/': typeof AuthenticatedAdminFeatureFlagsIndexRoute
  '/_authenticated/admin/organizaciones/': typeof AuthenticatedAdminOrganizacionesIndexRoute
  '/_authenticated/admin/pagos/': typeof AuthenticatedAdminPagosIndexRoute
  '/_authenticated/admin/suscripciones/': typeof AuthenticatedAdminSuscripcionesIndexRoute
  '/_authenticated/admin/tenants/': typeof AuthenticatedAdminTenantsIndexRoute
  '/_authenticated/admin/workers/': typeof AuthenticatedAdminWorkersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/portal'
    | '/actividades'
    | '/admin'
    | '/api-docs'
    | '/audit'
    | '/dashboard'
    | '/enablement-rooms'
    | '/guia-afip'
    | '/guia-inicio'
    | '/onboarding'
    | '/settings'
    | '/about'
    | '/blog'
    | '/carreras'
    | '/changelog'
    | '/contacto'
    | '/cookies'
    | '/developers'
    | '/login'
    | '/precios'
    | '/privacidad'
    | '/productos'
    | '/roadmap'
    | '/signup'
    | '/status'
    | '/terminos'
    | '/certificates/csr'
    | '/portal/auth'
    | '/portal/login'
    | '/portal/'
    | '/alerts/category-change'
    | '/billing/history'
    | '/clients/new'
    | '/cuit-profiles/$id'
    | '/cuit-profiles/new'
    | '/dashboard/api'
    | '/dashboard/empresa'
    | '/dashboard/facturacion'
    | '/dashboard/metrics'
    | '/invoices/$id'
    | '/invoices/import'
    | '/auth/magic'
    | '/auth/verify-email'
    | '/developers/pagos'
    | '/estudios-amigos/aceptar'
    | '/admin/'
    | '/alerts/'
    | '/api-logs/'
    | '/aplicaciones/'
    | '/billing/'
    | '/certificados/'
    | '/clients/'
    | '/cobranzas/'
    | '/consumo/'
    | '/credenciales/'
    | '/cuit-profiles/'
    | '/honorarios/'
    | '/invoices/'
    | '/iva/'
    | '/paraguay/'
    | '/receptores/'
    | '/recurrentes/'
    | '/reportes/'
    | '/roles/'
    | '/users/'
    | '/vencimientos/'
    | '/ventanilla-virtual/'
    | '/vep/'
    | '/webhooks/'
    | '/admin/tenants/$id'
    | '/billing/checkout/return'
    | '/cuit-profiles/$id/enablement'
    | '/invoices/$id/edit'
    | '/admin/anuncios/'
    | '/admin/auditoria/'
    | '/admin/buscar/'
    | '/admin/certificados/'
    | '/admin/comprobantes/'
    | '/admin/configuracion/'
    | '/admin/cupones/'
    | '/admin/estado/'
    | '/admin/estudios-amigos/'
    | '/admin/feature-flags/'
    | '/admin/organizaciones/'
    | '/admin/pagos/'
    | '/admin/suscripciones/'
    | '/admin/tenants/'
    | '/admin/workers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/actividades'
    | '/api-docs'
    | '/audit'
    | '/dashboard'
    | '/enablement-rooms'
    | '/guia-afip'
    | '/guia-inicio'
    | '/onboarding'
    | '/settings'
    | '/about'
    | '/blog'
    | '/carreras'
    | '/changelog'
    | '/contacto'
    | '/cookies'
    | '/developers'
    | '/login'
    | '/precios'
    | '/privacidad'
    | '/productos'
    | '/roadmap'
    | '/signup'
    | '/status'
    | '/terminos'
    | '/certificates/csr'
    | '/portal/auth'
    | '/portal/login'
    | '/portal'
    | '/alerts/category-change'
    | '/billing/history'
    | '/clients/new'
    | '/cuit-profiles/$id'
    | '/cuit-profiles/new'
    | '/dashboard/api'
    | '/dashboard/empresa'
    | '/dashboard/facturacion'
    | '/dashboard/metrics'
    | '/invoices/$id'
    | '/invoices/import'
    | '/auth/magic'
    | '/auth/verify-email'
    | '/developers/pagos'
    | '/estudios-amigos/aceptar'
    | '/admin'
    | '/alerts'
    | '/api-logs'
    | '/aplicaciones'
    | '/billing'
    | '/certificados'
    | '/clients'
    | '/cobranzas'
    | '/consumo'
    | '/credenciales'
    | '/cuit-profiles'
    | '/honorarios'
    | '/invoices'
    | '/iva'
    | '/paraguay'
    | '/receptores'
    | '/recurrentes'
    | '/reportes'
    | '/roles'
    | '/users'
    | '/vencimientos'
    | '/ventanilla-virtual'
    | '/vep'
    | '/webhooks'
    | '/admin/tenants/$id'
    | '/billing/checkout/return'
    | '/cuit-profiles/$id/enablement'
    | '/invoices/$id/edit'
    | '/admin/anuncios'
    | '/admin/auditoria'
    | '/admin/buscar'
    | '/admin/certificados'
    | '/admin/comprobantes'
    | '/admin/configuracion'
    | '/admin/cupones'
    | '/admin/estado'
    | '/admin/estudios-amigos'
    | '/admin/feature-flags'
    | '/admin/organizaciones'
    | '/admin/pagos'
    | '/admin/suscripciones'
    | '/admin/tenants'
    | '/admin/workers'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/portal'
    | '/_authenticated/actividades'
    | '/_authenticated/admin'
    | '/_authenticated/api-docs'
    | '/_authenticated/audit'
    | '/_authenticated/dashboard'
    | '/_authenticated/enablement-rooms'
    | '/_authenticated/guia-afip'
    | '/_authenticated/guia-inicio'
    | '/_authenticated/onboarding'
    | '/_authenticated/settings'
    | '/_public/about'
    | '/_public/blog'
    | '/_public/carreras'
    | '/_public/changelog'
    | '/_public/contacto'
    | '/_public/cookies'
    | '/_public/developers'
    | '/_public/login'
    | '/_public/precios'
    | '/_public/privacidad'
    | '/_public/productos'
    | '/_public/roadmap'
    | '/_public/signup'
    | '/_public/status'
    | '/_public/terminos'
    | '/certificates/csr'
    | '/portal/auth'
    | '/portal/login'
    | '/_public/'
    | '/portal/'
    | '/_authenticated/alerts/category-change'
    | '/_authenticated/billing/history'
    | '/_authenticated/clients/new'
    | '/_authenticated/cuit-profiles/$id'
    | '/_authenticated/cuit-profiles/new'
    | '/_authenticated/dashboard/api'
    | '/_authenticated/dashboard/empresa'
    | '/_authenticated/dashboard/facturacion'
    | '/_authenticated/dashboard/metrics'
    | '/_authenticated/invoices/$id'
    | '/_authenticated/invoices/import'
    | '/_public/auth/magic'
    | '/_public/auth/verify-email'
    | '/_public/developers/pagos'
    | '/_public/estudios-amigos/aceptar'
    | '/_authenticated/admin/'
    | '/_authenticated/alerts/'
    | '/_authenticated/api-logs/'
    | '/_authenticated/aplicaciones/'
    | '/_authenticated/billing/'
    | '/_authenticated/certificados/'
    | '/_authenticated/clients/'
    | '/_authenticated/cobranzas/'
    | '/_authenticated/consumo/'
    | '/_authenticated/credenciales/'
    | '/_authenticated/cuit-profiles/'
    | '/_authenticated/honorarios/'
    | '/_authenticated/invoices/'
    | '/_authenticated/iva/'
    | '/_authenticated/paraguay/'
    | '/_authenticated/receptores/'
    | '/_authenticated/recurrentes/'
    | '/_authenticated/reportes/'
    | '/_authenticated/roles/'
    | '/_authenticated/users/'
    | '/_authenticated/vencimientos/'
    | '/_authenticated/ventanilla-virtual/'
    | '/_authenticated/vep/'
    | '/_authenticated/webhooks/'
    | '/_authenticated/admin/tenants/$id'
    | '/_authenticated/billing/checkout/return'
    | '/_authenticated/cuit-profiles/$id/enablement'
    | '/_authenticated/invoices/$id/edit'
    | '/_authenticated/admin/anuncios/'
    | '/_authenticated/admin/auditoria/'
    | '/_authenticated/admin/buscar/'
    | '/_authenticated/admin/certificados/'
    | '/_authenticated/admin/comprobantes/'
    | '/_authenticated/admin/configuracion/'
    | '/_authenticated/admin/cupones/'
    | '/_authenticated/admin/estado/'
    | '/_authenticated/admin/estudios-amigos/'
    | '/_authenticated/admin/feature-flags/'
    | '/_authenticated/admin/organizaciones/'
    | '/_authenticated/admin/pagos/'
    | '/_authenticated/admin/suscripciones/'
    | '/_authenticated/admin/tenants/'
    | '/_authenticated/admin/workers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
  CertificatesCsrRoute: typeof CertificatesCsrRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/portal/login': {
      id: '/portal/login'
      path: '/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PortalLoginRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/auth': {
      id: '/portal/auth'
      path: '/auth'
      fullPath: '/portal/auth'
      preLoaderRoute: typeof PortalAuthRouteImport
      parentRoute: typeof PortalRoute
    }
    '/certificates/csr': {
      id: '/certificates/csr'
      path: '/certificates/csr'
      fullPath: '/certificates/csr'
      preLoaderRoute: typeof CertificatesCsrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/terminos': {
      id: '/_public/terminos'
      path: '/terminos'
      fullPath: '/terminos'
      preLoaderRoute: typeof PublicTerminosRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/status': {
      id: '/_public/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof PublicStatusRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/roadmap': {
      id: '/_public/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof PublicRoadmapRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/productos': {
      id: '/_public/productos'
      path: '/productos'
      fullPath: '/productos'
      preLoaderRoute: typeof PublicProductosRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/privacidad': {
      id: '/_public/privacidad'
      path: '/privacidad'
      fullPath: '/privacidad'
      preLoaderRoute: typeof PublicPrivacidadRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/precios': {
      id: '/_public/precios'
      path: '/precios'
      fullPath: '/precios'
      preLoaderRoute: typeof PublicPreciosRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/developers': {
      id: '/_public/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof PublicDevelopersRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/cookies': {
      id: '/_public/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof PublicCookiesRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/contacto': {
      id: '/_public/contacto'
      path: '/contacto'
      fullPath: '/contacto'
      preLoaderRoute: typeof PublicContactoRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/changelog': {
      id: '/_public/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof PublicChangelogRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/carreras': {
      id: '/_public/carreras'
      path: '/carreras'
      fullPath: '/carreras'
      preLoaderRoute: typeof PublicCarrerasRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog': {
      id: '/_public/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof PublicBlogRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/guia-inicio': {
      id: '/_authenticated/guia-inicio'
      path: '/guia-inicio'
      fullPath: '/guia-inicio'
      preLoaderRoute: typeof AuthenticatedGuiaInicioRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/guia-afip': {
      id: '/_authenticated/guia-afip'
      path: '/guia-afip'
      fullPath: '/guia-afip'
      preLoaderRoute: typeof AuthenticatedGuiaAfipRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/enablement-rooms': {
      id: '/_authenticated/enablement-rooms'
      path: '/enablement-rooms'
      fullPath: '/enablement-rooms'
      preLoaderRoute: typeof AuthenticatedEnablementRoomsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-docs': {
      id: '/_authenticated/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof AuthenticatedApiDocsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/actividades': {
      id: '/_authenticated/actividades'
      path: '/actividades'
      fullPath: '/actividades'
      preLoaderRoute: typeof AuthenticatedActividadesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/webhooks/': {
      id: '/_authenticated/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AuthenticatedWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vep/': {
      id: '/_authenticated/vep/'
      path: '/vep'
      fullPath: '/vep/'
      preLoaderRoute: typeof AuthenticatedVepIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ventanilla-virtual/': {
      id: '/_authenticated/ventanilla-virtual/'
      path: '/ventanilla-virtual'
      fullPath: '/ventanilla-virtual/'
      preLoaderRoute: typeof AuthenticatedVentanillaVirtualIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vencimientos/': {
      id: '/_authenticated/vencimientos/'
      path: '/vencimientos'
      fullPath: '/vencimientos/'
      preLoaderRoute: typeof AuthenticatedVencimientosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reportes/': {
      id: '/_authenticated/reportes/'
      path: '/reportes'
      fullPath: '/reportes/'
      preLoaderRoute: typeof AuthenticatedReportesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recurrentes/': {
      id: '/_authenticated/recurrentes/'
      path: '/recurrentes'
      fullPath: '/recurrentes/'
      preLoaderRoute: typeof AuthenticatedRecurrentesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/receptores/': {
      id: '/_authenticated/receptores/'
      path: '/receptores'
      fullPath: '/receptores/'
      preLoaderRoute: typeof AuthenticatedReceptoresIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/paraguay/': {
      id: '/_authenticated/paraguay/'
      path: '/paraguay'
      fullPath: '/paraguay/'
      preLoaderRoute: typeof AuthenticatedParaguayIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/iva/': {
      id: '/_authenticated/iva/'
      path: '/iva'
      fullPath: '/iva/'
      preLoaderRoute: typeof AuthenticatedIvaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/honorarios/': {
      id: '/_authenticated/honorarios/'
      path: '/honorarios'
      fullPath: '/honorarios/'
      preLoaderRoute: typeof AuthenticatedHonorariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cuit-profiles/': {
      id: '/_authenticated/cuit-profiles/'
      path: '/cuit-profiles'
      fullPath: '/cuit-profiles/'
      preLoaderRoute: typeof AuthenticatedCuitProfilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/credenciales/': {
      id: '/_authenticated/credenciales/'
      path: '/credenciales'
      fullPath: '/credenciales/'
      preLoaderRoute: typeof AuthenticatedCredencialesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/consumo/': {
      id: '/_authenticated/consumo/'
      path: '/consumo'
      fullPath: '/consumo/'
      preLoaderRoute: typeof AuthenticatedConsumoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cobranzas/': {
      id: '/_authenticated/cobranzas/'
      path: '/cobranzas'
      fullPath: '/cobranzas/'
      preLoaderRoute: typeof AuthenticatedCobranzasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certificados/': {
      id: '/_authenticated/certificados/'
      path: '/certificados'
      fullPath: '/certificados/'
      preLoaderRoute: typeof AuthenticatedCertificadosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/': {
      id: '/_authenticated/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthenticatedBillingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/aplicaciones/': {
      id: '/_authenticated/aplicaciones/'
      path: '/aplicaciones'
      fullPath: '/aplicaciones/'
      preLoaderRoute: typeof AuthenticatedAplicacionesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-logs/': {
      id: '/_authenticated/api-logs/'
      path: '/api-logs'
      fullPath: '/api-logs/'
      preLoaderRoute: typeof AuthenticatedApiLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/': {
      id: '/_authenticated/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof AuthenticatedAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_public/estudios-amigos/aceptar': {
      id: '/_public/estudios-amigos/aceptar'
      path: '/estudios-amigos/aceptar'
      fullPath: '/estudios-amigos/aceptar'
      preLoaderRoute: typeof PublicEstudiosAmigosAceptarRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/developers/pagos': {
      id: '/_public/developers/pagos'
      path: '/pagos'
      fullPath: '/developers/pagos'
      preLoaderRoute: typeof PublicDevelopersPagosRouteImport
      parentRoute: typeof PublicDevelopersRoute
    }
    '/_public/auth/verify-email': {
      id: '/_public/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof PublicAuthVerifyEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/magic': {
      id: '/_public/auth/magic'
      path: '/auth/magic'
      fullPath: '/auth/magic'
      preLoaderRoute: typeof PublicAuthMagicRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/invoices/import': {
      id: '/_authenticated/invoices/import'
      path: '/invoices/import'
      fullPath: '/invoices/import'
      preLoaderRoute: typeof AuthenticatedInvoicesImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/$id': {
      id: '/_authenticated/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthenticatedInvoicesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/metrics': {
      id: '/_authenticated/dashboard/metrics'
      path: '/metrics'
      fullPath: '/dashboard/metrics'
      preLoaderRoute: typeof AuthenticatedDashboardMetricsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/facturacion': {
      id: '/_authenticated/dashboard/facturacion'
      path: '/facturacion'
      fullPath: '/dashboard/facturacion'
      preLoaderRoute: typeof AuthenticatedDashboardFacturacionRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/empresa': {
      id: '/_authenticated/dashboard/empresa'
      path: '/empresa'
      fullPath: '/dashboard/empresa'
      preLoaderRoute: typeof AuthenticatedDashboardEmpresaRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/api': {
      id: '/_authenticated/dashboard/api'
      path: '/api'
      fullPath: '/dashboard/api'
      preLoaderRoute: typeof AuthenticatedDashboardApiRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/cuit-profiles/new': {
      id: '/_authenticated/cuit-profiles/new'
      path: '/cuit-profiles/new'
      fullPath: '/cuit-profiles/new'
      preLoaderRoute: typeof AuthenticatedCuitProfilesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cuit-profiles/$id': {
      id: '/_authenticated/cuit-profiles/$id'
      path: '/cuit-profiles/$id'
      fullPath: '/cuit-profiles/$id'
      preLoaderRoute: typeof AuthenticatedCuitProfilesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/new': {
      id: '/_authenticated/clients/new'
      path: '/clients/new'
      fullPath: '/clients/new'
      preLoaderRoute: typeof AuthenticatedClientsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/history': {
      id: '/_authenticated/billing/history'
      path: '/billing/history'
      fullPath: '/billing/history'
      preLoaderRoute: typeof AuthenticatedBillingHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts/category-change': {
      id: '/_authenticated/alerts/category-change'
      path: '/alerts/category-change'
      fullPath: '/alerts/category-change'
      preLoaderRoute: typeof AuthenticatedAlertsCategoryChangeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/workers/': {
      id: '/_authenticated/admin/workers/'
      path: '/workers'
      fullPath: '/admin/workers/'
      preLoaderRoute: typeof AuthenticatedAdminWorkersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/tenants/': {
      id: '/_authenticated/admin/tenants/'
      path: '/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AuthenticatedAdminTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/suscripciones/': {
      id: '/_authenticated/admin/suscripciones/'
      path: '/suscripciones'
      fullPath: '/admin/suscripciones/'
      preLoaderRoute: typeof AuthenticatedAdminSuscripcionesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/pagos/': {
      id: '/_authenticated/admin/pagos/'
      path: '/pagos'
      fullPath: '/admin/pagos/'
      preLoaderRoute: typeof AuthenticatedAdminPagosIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/organizaciones/': {
      id: '/_authenticated/admin/organizaciones/'
      path: '/organizaciones'
      fullPath: '/admin/organizaciones/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizacionesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/feature-flags/': {
      id: '/_authenticated/admin/feature-flags/'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags/'
      preLoaderRoute: typeof AuthenticatedAdminFeatureFlagsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/estudios-amigos/': {
      id: '/_authenticated/admin/estudios-amigos/'
      path: '/estudios-amigos'
      fullPath: '/admin/estudios-amigos/'
      preLoaderRoute: typeof AuthenticatedAdminEstudiosAmigosIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/estado/': {
      id: '/_authenticated/admin/estado/'
      path: '/estado'
      fullPath: '/admin/estado/'
      preLoaderRoute: typeof AuthenticatedAdminEstadoIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/cupones/': {
      id: '/_authenticated/admin/cupones/'
      path: '/cupones'
      fullPath: '/admin/cupones/'
      preLoaderRoute: typeof AuthenticatedAdminCuponesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/configuracion/': {
      id: '/_authenticated/admin/configuracion/'
      path: '/configuracion'
      fullPath: '/admin/configuracion/'
      preLoaderRoute: typeof AuthenticatedAdminConfiguracionIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/comprobantes/': {
      id: '/_authenticated/admin/comprobantes/'
      path: '/comprobantes'
      fullPath: '/admin/comprobantes/'
      preLoaderRoute: typeof AuthenticatedAdminComprobantesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/certificados/': {
      id: '/_authenticated/admin/certificados/'
      path: '/certificados'
      fullPath: '/admin/certificados/'
      preLoaderRoute: typeof AuthenticatedAdminCertificadosIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/buscar/': {
      id: '/_authenticated/admin/buscar/'
      path: '/buscar'
      fullPath: '/admin/buscar/'
      preLoaderRoute: typeof AuthenticatedAdminBuscarIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/auditoria/': {
      id: '/_authenticated/admin/auditoria/'
      path: '/auditoria'
      fullPath: '/admin/auditoria/'
      preLoaderRoute: typeof AuthenticatedAdminAuditoriaIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/anuncios/': {
      id: '/_authenticated/admin/anuncios/'
      path: '/anuncios'
      fullPath: '/admin/anuncios/'
      preLoaderRoute: typeof AuthenticatedAdminAnunciosIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/invoices/$id/edit': {
      id: '/_authenticated/invoices/$id/edit'
      path: '/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof AuthenticatedInvoicesIdEditRouteImport
      parentRoute: typeof AuthenticatedInvoicesIdRoute
    }
    '/_authenticated/cuit-profiles/$id/enablement': {
      id: '/_authenticated/cuit-profiles/$id/enablement'
      path: '/enablement'
      fullPath: '/cuit-profiles/$id/enablement'
      preLoaderRoute: typeof AuthenticatedCuitProfilesIdEnablementRouteImport
      parentRoute: typeof AuthenticatedCuitProfilesIdRoute
    }
    '/_authenticated/billing/checkout/return': {
      id: '/_authenticated/billing/checkout/return'
      path: '/billing/checkout/return'
      fullPath: '/billing/checkout/return'
      preLoaderRoute: typeof AuthenticatedBillingCheckoutReturnRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/tenants/$id': {
      id: '/_authenticated/admin/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/admin/tenants/$id'
      preLoaderRoute: typeof AuthenticatedAdminTenantsIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminTenantsIdRoute: typeof AuthenticatedAdminTenantsIdRoute
  AuthenticatedAdminAnunciosIndexRoute: typeof AuthenticatedAdminAnunciosIndexRoute
  AuthenticatedAdminAuditoriaIndexRoute: typeof AuthenticatedAdminAuditoriaIndexRoute
  AuthenticatedAdminBuscarIndexRoute: typeof AuthenticatedAdminBuscarIndexRoute
  AuthenticatedAdminCertificadosIndexRoute: typeof AuthenticatedAdminCertificadosIndexRoute
  AuthenticatedAdminComprobantesIndexRoute: typeof AuthenticatedAdminComprobantesIndexRoute
  AuthenticatedAdminConfiguracionIndexRoute: typeof AuthenticatedAdminConfiguracionIndexRoute
  AuthenticatedAdminCuponesIndexRoute: typeof AuthenticatedAdminCuponesIndexRoute
  AuthenticatedAdminEstadoIndexRoute: typeof AuthenticatedAdminEstadoIndexRoute
  AuthenticatedAdminEstudiosAmigosIndexRoute: typeof AuthenticatedAdminEstudiosAmigosIndexRoute
  AuthenticatedAdminFeatureFlagsIndexRoute: typeof AuthenticatedAdminFeatureFlagsIndexRoute
  AuthenticatedAdminOrganizacionesIndexRoute: typeof AuthenticatedAdminOrganizacionesIndexRoute
  AuthenticatedAdminPagosIndexRoute: typeof AuthenticatedAdminPagosIndexRoute
  AuthenticatedAdminSuscripcionesIndexRoute: typeof AuthenticatedAdminSuscripcionesIndexRoute
  AuthenticatedAdminTenantsIndexRoute: typeof AuthenticatedAdminTenantsIndexRoute
  AuthenticatedAdminWorkersIndexRoute: typeof AuthenticatedAdminWorkersIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminTenantsIdRoute: AuthenticatedAdminTenantsIdRoute,
  AuthenticatedAdminAnunciosIndexRoute: AuthenticatedAdminAnunciosIndexRoute,
  AuthenticatedAdminAuditoriaIndexRoute: AuthenticatedAdminAuditoriaIndexRoute,
  AuthenticatedAdminBuscarIndexRoute: AuthenticatedAdminBuscarIndexRoute,
  AuthenticatedAdminCertificadosIndexRoute:
    AuthenticatedAdminCertificadosIndexRoute,
  AuthenticatedAdminComprobantesIndexRoute:
    AuthenticatedAdminComprobantesIndexRoute,
  AuthenticatedAdminConfiguracionIndexRoute:
    AuthenticatedAdminConfiguracionIndexRoute,
  AuthenticatedAdminCuponesIndexRoute: AuthenticatedAdminCuponesIndexRoute,
  AuthenticatedAdminEstadoIndexRoute: AuthenticatedAdminEstadoIndexRoute,
  AuthenticatedAdminEstudiosAmigosIndexRoute:
    AuthenticatedAdminEstudiosAmigosIndexRoute,
  AuthenticatedAdminFeatureFlagsIndexRoute:
    AuthenticatedAdminFeatureFlagsIndexRoute,
  AuthenticatedAdminOrganizacionesIndexRoute:
    AuthenticatedAdminOrganizacionesIndexRoute,
  AuthenticatedAdminPagosIndexRoute: AuthenticatedAdminPagosIndexRoute,
  AuthenticatedAdminSuscripcionesIndexRoute:
    AuthenticatedAdminSuscripcionesIndexRoute,
  AuthenticatedAdminTenantsIndexRoute: AuthenticatedAdminTenantsIndexRoute,
  AuthenticatedAdminWorkersIndexRoute: AuthenticatedAdminWorkersIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardApiRoute: typeof AuthenticatedDashboardApiRoute
  AuthenticatedDashboardEmpresaRoute: typeof AuthenticatedDashboardEmpresaRoute
  AuthenticatedDashboardFacturacionRoute: typeof AuthenticatedDashboardFacturacionRoute
  AuthenticatedDashboardMetricsRoute: typeof AuthenticatedDashboardMetricsRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardApiRoute: AuthenticatedDashboardApiRoute,
    AuthenticatedDashboardEmpresaRoute: AuthenticatedDashboardEmpresaRoute,
    AuthenticatedDashboardFacturacionRoute:
      AuthenticatedDashboardFacturacionRoute,
    AuthenticatedDashboardMetricsRoute: AuthenticatedDashboardMetricsRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedCuitProfilesIdRouteChildren {
  AuthenticatedCuitProfilesIdEnablementRoute: typeof AuthenticatedCuitProfilesIdEnablementRoute
}

const AuthenticatedCuitProfilesIdRouteChildren: AuthenticatedCuitProfilesIdRouteChildren =
  {
    AuthenticatedCuitProfilesIdEnablementRoute:
      AuthenticatedCuitProfilesIdEnablementRoute,
  }

const AuthenticatedCuitProfilesIdRouteWithChildren =
  AuthenticatedCuitProfilesIdRoute._addFileChildren(
    AuthenticatedCuitProfilesIdRouteChildren,
  )

interface AuthenticatedInvoicesIdRouteChildren {
  AuthenticatedInvoicesIdEditRoute: typeof AuthenticatedInvoicesIdEditRoute
}

const AuthenticatedInvoicesIdRouteChildren: AuthenticatedInvoicesIdRouteChildren =
  {
    AuthenticatedInvoicesIdEditRoute: AuthenticatedInvoicesIdEditRoute,
  }

const AuthenticatedInvoicesIdRouteWithChildren =
  AuthenticatedInvoicesIdRoute._addFileChildren(
    AuthenticatedInvoicesIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedActividadesRoute: typeof AuthenticatedActividadesRoute
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedApiDocsRoute: typeof AuthenticatedApiDocsRoute
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedEnablementRoomsRoute: typeof AuthenticatedEnablementRoomsRoute
  AuthenticatedGuiaAfipRoute: typeof AuthenticatedGuiaAfipRoute
  AuthenticatedGuiaInicioRoute: typeof AuthenticatedGuiaInicioRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedAlertsCategoryChangeRoute: typeof AuthenticatedAlertsCategoryChangeRoute
  AuthenticatedBillingHistoryRoute: typeof AuthenticatedBillingHistoryRoute
  AuthenticatedClientsNewRoute: typeof AuthenticatedClientsNewRoute
  AuthenticatedCuitProfilesIdRoute: typeof AuthenticatedCuitProfilesIdRouteWithChildren
  AuthenticatedCuitProfilesNewRoute: typeof AuthenticatedCuitProfilesNewRoute
  AuthenticatedInvoicesIdRoute: typeof AuthenticatedInvoicesIdRouteWithChildren
  AuthenticatedInvoicesImportRoute: typeof AuthenticatedInvoicesImportRoute
  AuthenticatedAlertsIndexRoute: typeof AuthenticatedAlertsIndexRoute
  AuthenticatedApiLogsIndexRoute: typeof AuthenticatedApiLogsIndexRoute
  AuthenticatedAplicacionesIndexRoute: typeof AuthenticatedAplicacionesIndexRoute
  AuthenticatedBillingIndexRoute: typeof AuthenticatedBillingIndexRoute
  AuthenticatedCertificadosIndexRoute: typeof AuthenticatedCertificadosIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedCobranzasIndexRoute: typeof AuthenticatedCobranzasIndexRoute
  AuthenticatedConsumoIndexRoute: typeof AuthenticatedConsumoIndexRoute
  AuthenticatedCredencialesIndexRoute: typeof AuthenticatedCredencialesIndexRoute
  AuthenticatedCuitProfilesIndexRoute: typeof AuthenticatedCuitProfilesIndexRoute
  AuthenticatedHonorariosIndexRoute: typeof AuthenticatedHonorariosIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedIvaIndexRoute: typeof AuthenticatedIvaIndexRoute
  AuthenticatedParaguayIndexRoute: typeof AuthenticatedParaguayIndexRoute
  AuthenticatedReceptoresIndexRoute: typeof AuthenticatedReceptoresIndexRoute
  AuthenticatedRecurrentesIndexRoute: typeof AuthenticatedRecurrentesIndexRoute
  AuthenticatedReportesIndexRoute: typeof AuthenticatedReportesIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVencimientosIndexRoute: typeof AuthenticatedVencimientosIndexRoute
  AuthenticatedVentanillaVirtualIndexRoute: typeof AuthenticatedVentanillaVirtualIndexRoute
  AuthenticatedVepIndexRoute: typeof AuthenticatedVepIndexRoute
  AuthenticatedWebhooksIndexRoute: typeof AuthenticatedWebhooksIndexRoute
  AuthenticatedBillingCheckoutReturnRoute: typeof AuthenticatedBillingCheckoutReturnRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActividadesRoute: AuthenticatedActividadesRoute,
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedApiDocsRoute: AuthenticatedApiDocsRoute,
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedEnablementRoomsRoute: AuthenticatedEnablementRoomsRoute,
  AuthenticatedGuiaAfipRoute: AuthenticatedGuiaAfipRoute,
  AuthenticatedGuiaInicioRoute: AuthenticatedGuiaInicioRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedAlertsCategoryChangeRoute:
    AuthenticatedAlertsCategoryChangeRoute,
  AuthenticatedBillingHistoryRoute: AuthenticatedBillingHistoryRoute,
  AuthenticatedClientsNewRoute: AuthenticatedClientsNewRoute,
  AuthenticatedCuitProfilesIdRoute:
    AuthenticatedCuitProfilesIdRouteWithChildren,
  AuthenticatedCuitProfilesNewRoute: AuthenticatedCuitProfilesNewRoute,
  AuthenticatedInvoicesIdRoute: AuthenticatedInvoicesIdRouteWithChildren,
  AuthenticatedInvoicesImportRoute: AuthenticatedInvoicesImportRoute,
  AuthenticatedAlertsIndexRoute: AuthenticatedAlertsIndexRoute,
  AuthenticatedApiLogsIndexRoute: AuthenticatedApiLogsIndexRoute,
  AuthenticatedAplicacionesIndexRoute: AuthenticatedAplicacionesIndexRoute,
  AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute,
  AuthenticatedCertificadosIndexRoute: AuthenticatedCertificadosIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedCobranzasIndexRoute: AuthenticatedCobranzasIndexRoute,
  AuthenticatedConsumoIndexRoute: AuthenticatedConsumoIndexRoute,
  AuthenticatedCredencialesIndexRoute: AuthenticatedCredencialesIndexRoute,
  AuthenticatedCuitProfilesIndexRoute: AuthenticatedCuitProfilesIndexRoute,
  AuthenticatedHonorariosIndexRoute: AuthenticatedHonorariosIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedIvaIndexRoute: AuthenticatedIvaIndexRoute,
  AuthenticatedParaguayIndexRoute: AuthenticatedParaguayIndexRoute,
  AuthenticatedReceptoresIndexRoute: AuthenticatedReceptoresIndexRoute,
  AuthenticatedRecurrentesIndexRoute: AuthenticatedRecurrentesIndexRoute,
  AuthenticatedReportesIndexRoute: AuthenticatedReportesIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVencimientosIndexRoute: AuthenticatedVencimientosIndexRoute,
  AuthenticatedVentanillaVirtualIndexRoute:
    AuthenticatedVentanillaVirtualIndexRoute,
  AuthenticatedVepIndexRoute: AuthenticatedVepIndexRoute,
  AuthenticatedWebhooksIndexRoute: AuthenticatedWebhooksIndexRoute,
  AuthenticatedBillingCheckoutReturnRoute:
    AuthenticatedBillingCheckoutReturnRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicDevelopersRouteChildren {
  PublicDevelopersPagosRoute: typeof PublicDevelopersPagosRoute
}

const PublicDevelopersRouteChildren: PublicDevelopersRouteChildren = {
  PublicDevelopersPagosRoute: PublicDevelopersPagosRoute,
}

const PublicDevelopersRouteWithChildren =
  PublicDevelopersRoute._addFileChildren(PublicDevelopersRouteChildren)

interface PublicRouteChildren {
  PublicAboutRoute: typeof PublicAboutRoute
  PublicBlogRoute: typeof PublicBlogRoute
  PublicCarrerasRoute: typeof PublicCarrerasRoute
  PublicChangelogRoute: typeof PublicChangelogRoute
  PublicContactoRoute: typeof PublicContactoRoute
  PublicCookiesRoute: typeof PublicCookiesRoute
  PublicDevelopersRoute: typeof PublicDevelopersRouteWithChildren
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPreciosRoute: typeof PublicPreciosRoute
  PublicPrivacidadRoute: typeof PublicPrivacidadRoute
  PublicProductosRoute: typeof PublicProductosRoute
  PublicRoadmapRoute: typeof PublicRoadmapRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicStatusRoute: typeof PublicStatusRoute
  PublicTerminosRoute: typeof PublicTerminosRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicAuthMagicRoute: typeof PublicAuthMagicRoute
  PublicAuthVerifyEmailRoute: typeof PublicAuthVerifyEmailRoute
  PublicEstudiosAmigosAceptarRoute: typeof PublicEstudiosAmigosAceptarRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,
  PublicBlogRoute: PublicBlogRoute,
  PublicCarrerasRoute: PublicCarrerasRoute,
  PublicChangelogRoute: PublicChangelogRoute,
  PublicContactoRoute: PublicContactoRoute,
  PublicCookiesRoute: PublicCookiesRoute,
  PublicDevelopersRoute: PublicDevelopersRouteWithChildren,
  PublicLoginRoute: PublicLoginRoute,
  PublicPreciosRoute: PublicPreciosRoute,
  PublicPrivacidadRoute: PublicPrivacidadRoute,
  PublicProductosRoute: PublicProductosRoute,
  PublicRoadmapRoute: PublicRoadmapRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicStatusRoute: PublicStatusRoute,
  PublicTerminosRoute: PublicTerminosRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicAuthMagicRoute: PublicAuthMagicRoute,
  PublicAuthVerifyEmailRoute: PublicAuthVerifyEmailRoute,
  PublicEstudiosAmigosAceptarRoute: PublicEstudiosAmigosAceptarRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface PortalRouteChildren {
  PortalAuthRoute: typeof PortalAuthRoute
  PortalLoginRoute: typeof PortalLoginRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAuthRoute: PortalAuthRoute,
  PortalLoginRoute: PortalLoginRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  CertificatesCsrRoute: CertificatesCsrRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
